import {MarketingParams} from "../../../common/interfaces/marketing-params.interface";


export interface OpenLinkParams {
  source?: string;
  sourceLink?: string;
  options?: any;
  view?: string;
  resolveByCallback?: boolean;
}



export interface OpenMyAccountOptions {
  tabId: number;
}

export interface OpenContactUsOptions{
  view: string;
}

export enum OpenMembershipResponse {
  unknown = 0,
  play = 1,
  deposit = 2,
  close = 3
}



export interface IExternalLinksService {
  openLink(params: OpenLinkParams, marketingParams?: MarketingParams, useCallbackURL?: boolean): Promise<any>;
  openMyAccount(options?: OpenMyAccountOptions, marketingParams?: MarketingParams, resolveByCallback?: boolean): Promise<any>;
  openMembership(marketingParams?: MarketingParams, resolveByCallback?: boolean): Promise<OpenMembershipResponse>;
  openUploadDocument(marketingParams?: MarketingParams, resolveByCallback?: boolean): Promise<any>;
  openContactUs(options?: OpenContactUsOptions, marketingParams?: MarketingParams, resolveByCallback?: boolean): Promise<any>;
  openHelpPage(): Promise<any>;
  openDownloadApp(): Promise<any>;
  openResponsibleGamblingLink(view?:number):void;
  openOldChat(): Promise<void>;
}
